/**
 * @file useDirectoryList.ts
 * @description Загрузка записей справочника каталога (phase19.31, каркас (б)):
 * список, загрузка, ошибка человеческим текстом, перечитывание после правки.
 *
 * Один хук на теги, производителей, поставщиков и акции — раньше каждая
 * страница держала свою копию `refresh` с разными текстами ошибок. Ошибка при
 * уже показанном списке его не стирает (`ResponsiveList` покажет полосу).
 */

import { useCallback, useEffect, useRef, useState } from "react";

import { ApiError } from "../../../lib/api-client";

export function useDirectoryList<T>(load: () => Promise<T[]>, errorText: string) {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Загрузчик — в ref: страница передаёт новую стрелку на каждой отрисовке.
  const loader = useRef(load);
  loader.current = load;

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setItems(await loader.current());
      setError(null);
    } catch (err) {
      if (!(err instanceof ApiError) && import.meta.env.DEV) console.warn(errorText, err);
      setError(`${errorText}. Проверьте связь и попробуйте ещё раз`);
    } finally {
      setLoading(false);
    }
  }, [errorText]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { items, loading, error, refresh };
}
